import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      marginTop: "12%",
      padding: 0,
    },

    slideInner: {
      textAlign: "center",

      [theme.breakpoints.down("xs")]: {
        paddingLeft: 20,
        paddingRight: 20,
      },
    },

    error: {
      display: "block",
      color: "red",
      fontSize: 14,
      fontWeight: theme.typography.fontWeightLight,
    },
  }),
  {
    name: "business-search-style",
    flip: null,
  }
);
